import jwtDataFunction from './jwtDataFunction';
import { isNil } from '@/shared/utils';

export default function canAccessConfigMiddleware({ next, router, localStore }) {
	let token = localStorage.getItem('jwt-token');
	const canAccessConfig = () => {
		if (isNil(jwtDataFunction(token).TokenData)) return false;
		const ret = jwtDataFunction(token).TokenData.CanAccessConfig;
		if (ret) {
			return ret;
		}
		return false;
	};

	if (!canAccessConfig()) {
		router.replace({ name: 'Page404' });
	}

	next();
}
